<template>
  <section
    class="container h-full max-w-full mx-auto px-4 sm:px-6 lg:px-8 py-12 min-h-screen pt-5 md:pt-10 lg:pt-12">
    <Titre textePrincipal="Nos chatons 0 à 5 mois pour " texteAccentue="adoption" :isSidebarOpen="isSidebarOpen" />
    <p class="mb-10 w-full"></p>

    <div class="max-w-full flex flex-wrap flex-row justify-center items-stretch gap-6 mb-20">

      <Card v-for="(card, index) in cards" :key="index" :title="card.title" :details="card.details" :reserved="card.reserved"
        :isMale="card.isMale"
        :infoAdditionnel="card.infoAdditionnel"
        :imageSrc="card.imageSrc" :altText="card.altText" :imageTitle="card.imageTitle"
        :chatFemelleAdoptee="card.chatFemelleAdoptee || false"
        :chatMaleAdopte="card.chatMaleAdopte || false">

        <!-- Choix automatique du bouton selon sexe -->
        <template v-if="card.details[0] && card.details[0].toLowerCase().includes('mâle')">
          <BoutonBleu />
        </template>
        <template v-else>
          <BoutonRose />
        </template>

      </Card>
      <div v-if="cards.length === 0" class="text-center text-gray-500">Aucun chaton de 0 à 5 mois à afficher.</div>

    </div>
    <div class="container flex flex-wrap flex-row justify-center gap-6 mb-10">
      <router-link to="/chats-males" class="px-4 py-2 text-white bg-navigation hover:bg-primaire rounded-md" aria-label="Voir les chats mâles de 1 an et plus" title="Voir les chats mâles de 1 an et plus">
        ◄ Chats mâles 1 an et +
      </router-link>
      <router-link to="/chatons-6-12-mois" class="px-4 py-2 text-white bg-navigation hover:bg-primaire rounded-md" aria-label="Voir les chatons de 6 à 12 mois" title="Voir les chatons de 6 à 12 mois">
        Chatons (6-12 mois) ►
      </router-link>
    </div>
    <div class="container flex flex-column justify-center items-center flex-col mb-10">
      <p class="text-2xl text-gray-700 mb-4">Vous avez un coup de coeur ?</p>
      <span class="ml-2">
        <a href="mailto:info@animauxdelasecondechance.com?subject=Adoption d'un chaton !&body=Bonjour, j'aimerais adopter un chaton. Message :"
          target="_blank" title="Écrivez-nous !" rel="noopener noreferrer"
          class="inline-flex items-center px-3 py-2 mt-5 text-sm sm:text-md md:text-lg font-medium text-center text-white bg-action rounded-lg hover:bg-navigation focus:ring-4 focus:outline-none focus:ring-white dark:primaire dark:hover:bg-navigation dark:focus:ring-white">
          Contactez-nous !
        </a>
      </span>
    </div>
  </section>
</template>

<script setup>
import Titre from '../composants/Titre.vue';
import Card from '../composants/Card.vue';
import BoutonRose from '../composants/BoutonRose.vue';
import BoutonBleu from '../composants/BoutonBleu.vue';
import { isSidebarOpen } from '../store/storeSideBar.js';

import { useListeChatons0_5Mois } from '../composables/apiListeChats.js';
import { computed, onMounted } from 'vue';

const { listeChatons0_5Mois, chargerListeChatons0_5Mois } = useListeChatons0_5Mois();

onMounted(() => {
  chargerListeChatons0_5Mois();
});

const cards = computed(() =>
  listeChatons0_5Mois.value
    .filter(chat => !chat.date_adoption || chat.date_adoption.trim() === '')
      .sort((a, b) => {
        const noA = Number(a.no_identification || 0);
        const noB = Number(b.no_identification || 0);
        return noB - noA; // Tri décroissant par numéro d'identification
      })
  .map(chat => {
      const sterilisation = (chat.sterilisation && chat.sterilisation.toLowerCase() === 'oui')
        ? (chat.type && chat.type.toLowerCase() === 'femelle' ? 'Stérilisée' : 'Stérilisé')
        : null;

      const vaccinVermifugeList = [];

      if (chat.vaccin && chat.vaccin.toLowerCase() === 'oui') {
        vaccinVermifugeList.push(chat.type && chat.type.toLowerCase() === 'femelle' ? 'vaccinée' : 'vacciné');
      }
      if (chat.vermifuge && chat.vermifuge.toLowerCase() === 'oui') {
        vaccinVermifugeList.push(chat.type && chat.type.toLowerCase() === 'femelle' ? 'vermifugée' : 'vermifugé');
      }

      function joinWithEt(arr) {
        if (arr.length === 0) return '';
        if (arr.length === 1) return arr[0];
        return arr.slice(0, -1).join(', ') + ' et ' + arr[arr.length - 1];
      }

      const vaccinVermifuge = joinWithEt(vaccinVermifugeList);

      let sterilisationVaccinVermifuge = '';

      if (sterilisation && vaccinVermifuge) {
        sterilisationVaccinVermifuge = `${sterilisation}, ${vaccinVermifuge}`;
      } else if (sterilisation) {
        sterilisationVaccinVermifuge = sterilisation;
      } else if (vaccinVermifuge) {
        sterilisationVaccinVermifuge = vaccinVermifuge;
      }

      return {
        ...chat,
        title: `${chat.nom}\u00A0\u00A0#${chat.no_identification || 'N/A'}`,
        no_identification: chat.no_identification,
        reserved:
          chat.reserve === 1 || chat.reserve === "oui" || chat.reserve === '1'
            ? "oui"
            : "non",
        isMale: chat.type && chat.type.toLowerCase() === 'mâle',
        details: [
          chat.type
            ? `${chat.type} ${chat.type.toLowerCase() === 'femelle' ? 'née' : 'né'}  ${chat.date_de_naissance || 'N/A'}`
            : '',
          sterilisationVaccinVermifuge,
        ].filter(Boolean),
        imageSrc: chat.image,
        altText: chat.nom,
        imageTitle: chat.nom,
        infoAdditionnel: chat.info_additionnelle || chat.infoAdditionnel || '',
      };
    })
);

</script>

<style scoped>
</style>